import React from "react";
import ReactSelect from "react-select";
import CreatableSelect from "react-select/creatable";
import { useTranslation } from "./hooks/useTranslation";
export const bootstrapStyle = {
    control: (styles) => ({
        ...styles,
        minHeight: "34px",
        transition: "none",
    }),
    clearIndicator: (styles) => ({
        ...styles,
        padding: "2px 8px",
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        padding: "2px 8px",
    }),
    loadingIndicator: (styles) => ({
        ...styles,
        padding: "2px 8px",
    }),
    menu: (styles) => ({
        ...styles,
        zIndex: 3, // Without this menu will be overlapped by other fields
    }),
    noOptionsMessage: (styles) => ({
        ...styles,
        // react-select defaults this notice to hsl(0, 0%, 60%), which is about
        // 2.9:1 on white and fails WCAG AA. The notice carries real explanations
        // and not just placeholder hints, so it uses the body text colour
        // ($text-color) instead.
        color: "#435969",
    }),
    option: (styles) => ({
        ...styles,
        minHeight: "29px",
        height: "inherit",
    }),
};
/**
 * Presentational select: react-select with piston styling and no form
 * system attached. Fully controlled through `value`/`onChange`, so it can
 * be wired to any form library (e.g. react-hook-form) or used standalone.
 */
export const BaseSelect = ({ options, value, onChange, onBlur, components, multiple = false, disabled = false, autoFocus = false, loading = false, formatter = (option) => option.label, placeholder, isClearable = true, ariaLabelledby, ariaLabel, id, creatable = false, menuPortalTarget, dataId, dataTestId, }) => {
    const t = useTranslation();
    if (placeholder === undefined) {
        placeholder = `${t("Select")}...`;
    }
    const Component = creatable
        ? CreatableSelect
        : ReactSelect;
    return (React.createElement(Component, { "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, id: id, components: components, styles: bootstrapStyle, isMulti: multiple, options: options, value: value, onChange: onChange, onBlur: onBlur, isClearable: isClearable, getOptionValue: JSON.stringify, getOptionLabel: formatter, className: "react-select", isDisabled: disabled || loading, classNamePrefix: "select", autoFocus: autoFocus, isLoading: loading, placeholder: placeholder, menuPortalTarget: menuPortalTarget, "data-id": dataId, "data-testid": dataTestId, ...(creatable ? { noOptionsMessage: () => null } : {}) }));
};
